var map = {
	"./burger_icon.svg": 522,
	"./camp.svg": 1068,
	"./creative.svg": 1069,
	"./cross.svg": 523,
	"./earth_group.svg": 1070,
	"./feature_1.svg": 1071,
	"./feature_2.png": 549,
	"./feature_2.svg": 1072,
	"./feature_3.svg": 1073,
	"./flag.svg": 920,
	"./frontend.svg": 1074,
	"./gamedesign.svg": 1075,
	"./graphicdesign.svg": 1076,
	"./junior.svg": 1077,
	"./map_yellow.svg": 919,
	"./math_circles_bg.svg": 1078,
	"./math_circles_bg_sm.svg": 1079,
	"./math_courses_1.svg": 1080,
	"./math_courses_2.svg": 1081,
	"./math_road_line_1.svg": 1082,
	"./math_road_line_2.svg": 1083,
	"./math_road_line_3.svg": 1084,
	"./math_road_line_4.svg": 1085,
	"./maths_logo.svg": 1086,
	"./maths_logo_white.svg": 1087,
	"./pc.svg": 1088,
	"./programming_bg.svg": 1089,
	"./programming_bg_sm.svg": 1090,
	"./programming_comment_1.svg": 586,
	"./programming_comment_2.svg": 587,
	"./programming_comment_3.svg": 588,
	"./programming_logo-en.svg": 584,
	"./programming_logo-ru.svg": 583,
	"./programming_logo_white.svg": 582,
	"./programming_puzzles.svg": 581,
	"./programming_square.svg": 923,
	"./programming_summer.svg": 1091,
	"./pytpro.svg": 1092,
	"./pytstart.svg": 1093,
	"./school.svg": 921,
	"./share_icon_violet.svg": 924,
	"./share_icon_white.svg": 589,
	"./smile.svg": 922,
	"./tg_logo.svg": 521,
	"./tg_logo_white.svg": 525,
	"./unity.svg": 1094,
	"./videocontent.svg": 1095,
	"./websites.svg": 1096,
	"./whats_logo.svg": 520,
	"./whats_logo_white.svg": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1067;